import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Compass = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Compass" {...props}>
    <path d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM14.8037 8.01953C15.1316 7.95396 15.4706 8.05655 15.707 8.29297C15.9435 8.52939 16.046 8.86843 15.9805 9.19629L14.9805 14.1963C14.9012 14.592 14.592 14.9012 14.1963 14.9805L9.19629 15.9805C8.86843 16.046 8.52939 15.9435 8.29297 15.707C8.05655 15.4706 7.95396 15.1316 8.01953 14.8037L9.01953 9.80371L9.05957 9.66016C9.17715 9.33453 9.45729 9.08888 9.80371 9.01953L14.8037 8.01953ZM12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11Z" fill="#000" />
  </StyledIcon>
));

Compass.displayName = 'Compass';

export { Compass };
